import React from 'react';
import { TableRow, TableCell, Skeleton } from '@mui/material';

const LoadingTableBody = ({ rows = 5, columns = 4, cellHeight = 30 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={`skeleton-cell-${rowIndex}-${colIndex}`}>
              <Skeleton height={cellHeight} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default LoadingTableBody;
